import { c13132E } from '#/colors';

interface Props {
  readonly size?: number;
  readonly color?: string;
  readonly className?: string;
}

export default function WarningIcon(props: Props) {
  const { size = 20, color = c13132E, className } = props;

  return (
    <svg
      width={size}
      viewBox="0 0 19.97 16.47"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.07.32a2 2 0 0 1 .6.6l7.99 12.47a2 2 0 0 1-1.69 3.08H2a2 2 0 0 1-1.68-3.08L8.3.92a2 2 0 0 1 2.77-.6ZM10 12.06a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm0-7.99h-.03a.96.96 0 0 0-.93 1l.18 5.24a.78.78 0 0 0 1.56 0l.19-5.24a.97.97 0 0 0-.97-1Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}
